import styled from 'styled-components';

export const Container = styled.div`
    width: 150px;
    height: 48px;
    display: flex;
`;
